import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ChevronRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDay, venceText } from "@/lib/solicitudes";
import { MemberAvatar } from "@/components/red/MemberAvatar";
import { EstadoBadge } from "@/components/red/EstadoBadge";

const Row = ({ s, enviada }) => {
  const m = enviada ? s.dueno : s.solicitante;
  return (
    <Link to={`/conecta/solicitudes/${s.id}`} data-testid="solicitud-row" className="c-card p-3.5 flex items-center gap-3 active:scale-[0.99] transition-transform">
      <MemberAvatar m={m} size="w-10 h-10 text-sm" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold truncate">{enviada ? `A ${m.nombre_publico}` : m.nombre_publico}</p>
        <p className="text-xs c-text-2 truncate">{s.servicio_nombre}{s.ciudad ? ` · ${s.ciudad}` : ""} · {s.necesidad}</p>
        <p className="text-[11px] c-muted">{fmtDay(s.created_at)}{s.estado === "pendiente" ? ` · ${venceText(s.vence_en)}` : ""}</p>
      </div>
      <EstadoBadge estado={s.estado} />
      <ChevronRight className="w-4 h-4 c-muted shrink-0" />
    </Link>
  );
};

export default function SolicitudesPage() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") === "enviadas" ? "enviadas" : "recibidas";
  const [d, setD] = useState(null);
  useEffect(() => {
    setD(null);
    api.get("/red/solicitudes", { params: { tipo: tab } }).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [tab]);
  const Tab = ({ k, label }) => (
    <button data-testid={`solicitudes-tab-${k}`} onClick={() => setSp({ tab: k })} className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-colors ${tab === k ? "bg-[var(--c-card)] shadow c-accent" : "c-muted"}`}>{label}</button>
  );
  return (
    <div data-testid="solicitudes-page" className="space-y-3">
      <div className="flex gap-1 p-1 rounded-xl bg-[var(--c-elev)]">
        <Tab k="recibidas" label={`Recibidas${d?.pendientes ? ` (${d.pendientes})` : ""}`} />
        <Tab k="enviadas" label="Enviadas" />
      </div>
      {!d ? <div className="py-12 flex justify-center"><Loader2 className="w-6 h-6 animate-spin c-muted" /></div> : d.items.length === 0 ? (
        <p data-testid="solicitudes-empty" className="c-card p-6 text-sm c-text-2 text-center">
          {tab === "recibidas" ? "Aún no te han pedido presentaciones." : <>Aún no pides presentaciones. <Link to="/conecta/buscar" className="c-accent font-semibold">Busca en la red</Link></>}
        </p>
      ) : (
        <div data-testid={`solicitudes-list-${tab}`} className="space-y-2">{d.items.map((s) => <Row key={s.id} s={s} enviada={tab === "enviadas"} />)}</div>
      )}
    </div>
  );
}
